@if (processorName) {
    <lib-adyen-advanced
        [isGuest]="isGuest"
        [clientCart]="paymentCart"
        [totalAmount]="totalAmount"
        [displayCancelButton]="false"
        [displayAdyenPayButton]="true"
        (responseAdyen)="adyenPaypalResponse($event)"
    />
}
@if (isPaying) {
    <div id="paypal-button-processing">
        <button matButton="filled" color="primary" class="mt-3 w-100" disabled>
            <span>{{ isLoading ? 'PAYING' : 'LOADING' }}</span>
            <mat-icon class="ms-2 spinner-icon d-inline-flex" iconPositionEnd>
                <mat-spinner diameter="16" />
            </mat-icon>
        </button>
    </div>
}
